module.exports = __webpack_public_path__ + "img/lb_menu_bg_d_r.4a1b328d.png";